"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSanitizedStackingConfig = exports.sanitizeConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
function isItemsArray(obj) {
    return !isEmpty_1.default(obj) && (sdk_model_1.isMeasure(obj[0]) || sdk_model_1.isAttribute(obj));
}
function sanitizeConfig(input, config) {
    if (input === void 0) { input = []; }
    if (config === void 0) { config = {}; }
    if (!input.length) {
        return config;
    }
    var items = isItemsArray(input) ? input : sdk_model_1.bucketItems(sdk_model_1.bucketsFind(input, sdk_ui_1.BucketNames.MEASURES));
    if (items) {
        var isComputeRatio = isComputeRatioMeasure(items[0]);
        var stackMeasures = config.stackMeasures, stackMeasuresToPercent = config.stackMeasuresToPercent;
        return tslib_1.__assign(tslib_1.__assign({}, config), { stackMeasures: stackMeasures && !isComputeRatio, stackMeasuresToPercent: stackMeasuresToPercent && !isComputeRatio });
    }
    return config;
}
exports.sanitizeConfig = sanitizeConfig;
function isComputeRatioMeasure(bucketItem) {
    return sdk_model_1.isMeasure(bucketItem) && sdk_model_1.measureDoesComputeRatio(bucketItem);
}
function getSanitizedStackingConfig(executionDef, chartConfig) {
    if (executionDef.measures.length === 1) {
        var stackMeasures = chartConfig.stackMeasures, stackMeasuresToPercent = chartConfig.stackMeasuresToPercent;
        var singleMeasure = executionDef.measures[0];
        var isComputeRatio = sdk_model_1.measureDoesComputeRatio(singleMeasure);
        return tslib_1.__assign(tslib_1.__assign({}, chartConfig), { stackMeasures: stackMeasures && !isComputeRatio, stackMeasuresToPercent: stackMeasuresToPercent && !isComputeRatio });
    }
    return chartConfig;
}
exports.getSanitizedStackingConfig = getSanitizedStackingConfig;
//# sourceMappingURL=sanitizeStacking.js.map